import { rand } from '../engine/util';

/**
 * 仿B站弹幕飘屏层(DOM)。覆盖在世界画布之上,
 * 让"弹幕划过 → 世界随之变化"的因果在录像里直观可见(GDD Phase0 任务c)。
 */
export class DanmakuOverlay {
  private host: HTMLElement;
  private lane = 0;

  constructor(parent: HTMLElement) {
    this.host = document.createElement('div');
    this.host.className = 'dm-layer';
    parent.appendChild(this.host);
  }

  shoot(text: string, kind: 'danmaku' | 'comment' = 'danmaku') {
    const el = document.createElement('div');
    el.className = kind === 'comment' ? 'dm dm-comment' : 'dm';
    el.textContent = text;
    // 分道,避免叠字
    const lanes = 10;
    this.lane = (this.lane + 1) % lanes;
    const top = 4 + (this.lane / lanes) * 42 + rand(-1.5, 1.5);
    el.style.top = `${top}%`;
    this.host.appendChild(el);
    const dur = kind === 'comment' ? 8200 : rand(5200, 7200);
    const w = this.host.clientWidth || 600;
    const anim = el.animate(
      [{ transform: `translateX(${w}px)` }, { transform: 'translateX(-110%)' }],
      { duration: dur, easing: 'linear' },
    );
    anim.onfinish = () => el.remove();
  }

  /** 投币雨:金币字符从天而降(大投币场景) */
  coinRain(n: number) {
    const w = this.host.clientWidth || 600;
    for (let i = 0; i < Math.min(n, 40); i++) {
      const el = document.createElement('div');
      el.className = 'dm-coin';
      // B站硬币:使用官方原图(web/public/coin.png)
      el.innerHTML = `<img src="/coin.png" width="26" height="26" style="display:block" alt="币">`;
      el.style.left = `${rand(4, 92)}%`;
      this.host.appendChild(el);
      const delay = rand(0, 900);
      const anim = el.animate(
        [
          { transform: 'translateY(-40px)', opacity: 1 },
          { transform: `translateY(${this.host.clientHeight * 0.7}px)`, opacity: 0.2 },
        ],
        { duration: rand(1100, 1900), delay, easing: 'cubic-bezier(.4,.1,.7,1)' },
      );
      anim.onfinish = () => el.remove();
    }
    void w;
  }

  clear() { this.host.innerHTML = ''; }
}
